module.exports = __webpack_public_path__ + "media/images/service/n_6-bd8859e6d66527824f112f7b2c2e775f.jpg";